class ToScroll{
    constructor() {
        this.topBtn = document.querySelectorAll('.js-top-button');
        // this.smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
        this.toTop();
        // this.to();
    }

    toTop(){
        this.topBtn.forEach(el => {
            el.addEventListener("click", () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    // to(){
    //     this.smoothScrollTrigger.forEach(el => {
    //         el.addEventListener("click", (e) => {
    //             e.preventDefault();
    //             let href = el.getAttribute('href');
    //             let targetElement = document.getElementById(href.replace('#', ''));
    //             const rect = targetElement.getBoundingClientRect().top;
    //             const offset = window.pageYOffset;
    //             const gap = 60;
    //             const target = rect + offset - gap;
    //             window.scrollTo({
    //                 top: target,
    //                 behavior: 'smooth',
    //             });
    //         });
    //     });
    // }
}
export default ToScroll